<template>
  <transition name="env-fade">
    <div
      v-if="shouldShow"
      class="env-notifier"
      role="status"
      aria-live="polite"
      :title="`Environment: ${effectiveEnv}`"
    >
      Environment: <strong class="text-white">{{ effectiveEnv }}</strong>
    </div>
  </transition>
</template>

<script>
// Env comes from Vue CLI env (VUE_APP_*) or NODE_ENV.
// You can also pass it as a prop if you prefer.
export default {
  name: 'EnvNotifier',
  props: {
    // If you want to override via prop, pass env="staging" etc.
    env: { type: String, default: null },
    // Hide on production by default (same as Blade)
    hideOn: { type: String, default: 'production' }
  },
  computed: {
    // Try prop -> VUE_APP_ENV -> NODE_ENV
    effectiveEnv () {
      return (
        this.env ||
        ''
      )
    },
    shouldShow () {
      // show only when effectiveEnv exists and is not the hideOn value
      return !!this.effectiveEnv && this.effectiveEnv !== this.hideOn
    }
  }
}
</script>

<style scoped>
.env-notifier {
  position: fixed;
  box-sizing: border-box;
  width: 100%;
  background: #f00;
  color: #fff;
  font-weight: 600;
  text-align: center;
  border-bottom: 1px solid rgba(0,0,0,0.06);
  z-index: 100000;
}

/* simple fade */
.env-fade-enter-active, .env-fade-leave-active {
  transition: opacity .2s ease;
}
.env-fade-enter, .env-fade-leave-to {
  opacity: 0;
}
</style>